export const MAIN_CLASS_NAME = 'resizable-drawer';
export const RESIZE_BAR_CLASS_NAME = `${MAIN_CLASS_NAME}__resize-bar`;
